import { render, staticRenderFns } from "./image-view.vue?vue&type=template&id=41658f66&scoped=true&"
import script from "./image-view.vue?vue&type=script&lang=js&"
export * from "./image-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41658f66",
  null
  
)

export default component.exports